import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SnackService } from './snack.service';
import { serverurl } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class StreamService {

    constructor(
        private http: HttpClient,
        private snack: SnackService
    ) { }


    async savePromotionLink(
        id: string,
        name: string,
        expireDate: string,
        targetId: string,
        targetType: string,
        counter: number | null,
        skipRegistration: boolean,
        credits: number | null
    ): Promise<Object | false> {
        return await new Promise((resolve) => {
            this.http.post(serverurl + '/tracks/promotion', { id, name, expireDate, targetId, targetType, counter, skipRegistration, credits }).subscribe({
                next: (data: any) => {
                    this.snack.success(data)
                    resolve(true);
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })

    }
    async createNewAgent(agent: any): Promise<Object | false> {
        return await new Promise((resolve) => {
            this.http.post(serverurl + '/agents', { agent }).subscribe({
                next: (data: any) => {
                    resolve(data)
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }

    async updateAgent(agent: any): Promise<Object | false> {
        return await new Promise((resolve) => {
            this.http.put(`${serverurl}/agents/${agent.id}`, { agent }).subscribe({
                next: (data: any) => {
                    resolve(data)
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }

    async addTrack(track: any): Promise<Object | false> {
        return await new Promise((resolve) => {
            this.http.post(serverurl + '/tracks', track).subscribe({
                next: (data: any) => {
                    resolve(data)
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }
    async deleteTrack(id: string): Promise<Object | false> {
        return await new Promise((resolve) => {
            this.http.delete(`${serverurl}/tracks/${id}`).subscribe({
                next: (data: any) => {
                    resolve(data)
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }

    async updateTrack(trackId: string, name: string | null, description: string | null, categoryId: string | null, status: any): Promise<Object | false> {
        return await new Promise((resolve) => {
            this.http.put(`${serverurl}/tracks/${trackId}`, { name, description, categoryId, status }).subscribe({
                next: (data: any) => {
                    resolve(data)
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }
    async addStream(trackId: string, name: any, description: string, orderNr: number): Promise<Object | false> {
        return await new Promise((resolve) => {
            this.http.post(serverurl + '/tracks/streams', { trackId, name, description, orderNr }).subscribe({
                next: (data: any) => {
                    resolve(data)
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }
    async deleteStream(id: string): Promise<Object | false> {
        return await new Promise((resolve) => {
            this.http.delete(`${serverurl}/tracks/streams/${id}`).subscribe({
                next: (data: any) => {
                    resolve(data)
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }
    async updateStream(trackId: string, streamId: string, name: string | null, description: string | null, orderNr: number): Promise<Object | false> {
        return await new Promise((resolve) => {
            this.http.put(`${serverurl}/tracks/streams/${streamId}`, { trackId, name, description, orderNr }).subscribe({
                next: (data: any) => {
                    resolve(data)
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }
    async addStreamStep(streamId: string, stepTypeId: string, creditCosts: number, orderNr: number): Promise<Object | false> {
        return await new Promise((resolve) => {
            this.http.post(serverurl + '/tracks/streams/steps', { streamId, stepTypeId, creditCosts, orderNr }).subscribe({
                next: (data: any) => {
                    resolve(data)
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }
    async deleteStreamStep(id: string): Promise<Object | false> {
        return await new Promise((resolve) => {
            this.http.delete(`${serverurl}/tracks/streams/steps/${id}`).subscribe({
                next: (data: any) => {
                    resolve(data)
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }
    async updateStreamStep(id: string, streamId: string, stepTypeId: string, creditCosts: number, orderNr: number, maxIndexInitPrompts: number, maxIndexStepPrompts: number, maxIndexClosingPrompts: number): Promise<Object | false> {
        return await new Promise((resolve) => {
            this.http.put(`${serverurl}/tracks/streams/steps/${id}`, { streamId, stepTypeId, creditCosts, orderNr, maxIndexInitPrompts, maxIndexStepPrompts, maxIndexClosingPrompts }).subscribe({
                next: (data: any) => {
                    resolve(data)
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }
    async updateAllOrderNrOfStreamSteps(newStepsOrder: any): Promise<Object | false> {
        return await new Promise((resolve) => {
            this.http.put(`${serverurl}/tracks/streams/reordersteps`, { newStepsOrder }).subscribe({
                next: (data: any) => {
                    resolve(data)
                },
                error: (err) => {
                    this.snack.error(err);
                    resolve(false);
                }
            })
        })
    }
}
